import { concat, Observable } from 'rxjs';
import { last, toArray } from 'rxjs/operators';

export function makeSequentialRequests<T>(requests$: Observable<T>[]): Observable<T[]> {
    return concat(...requests$.map(o => o.pipe(last()))).pipe(toArray());
}
